import React from 'react';
import { Form } from 'react-bootstrap';
import cn from './../../helpers/cn';

const TextFieldInput = ({
  formLabel,
  formik,
  addAsterisk,
  defaultValue,
  inputClass,
  labelClass,
  formGroupClass,
  name,
  ...props
}) => {
  const Asterisk = () =>
    addAsterisk ? <span className="asterik">*</span> : null;

  const FormikError = () =>
    formik && formik.touched[name] && formik.errors[name] ? (
      <div className="form-input-error">{formik.errors[name]}</div>
    ) : null;

  return (
    <Form.Group className={cn('col-6 mb-2', formGroupClass)}>
      <Form.Label className={cn('user-form-label', labelClass)}>
        {formLabel}
      </Form.Label>
      <Asterisk />
      <Form.Control
        type="text"
        className={cn('user-form-input', inputClass)}
        defaultValue={defaultValue}
        {...props}
      />
      <FormikError />
    </Form.Group>
  );
};

export default React.memo(TextFieldInput);
